import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';
import { parseTeamMatrixSettings } from 'api/getTeamMatrixSettings';

const mutation = gql`
mutation UpdateTeamMatrixSettings($teamId: ID!, $model: TeamMatrixSettingInput!) {
  updateTeamMatrixSettings(teamId: $teamId, teamMatrixSetting: $model) {
    allRequestTypesOn
    allChannelsOn
    requestTypesIds
    channelsIds
  }
}`;

function updateTeamMatrixSettings({ teamId, model }) {
  return apollo.client.mutate({
    mutation,
    variables: { teamId, model },
  }).then((res) => parseTeamMatrixSettings(res.data.updateTeamMatrixSettings));
}

export default updateTeamMatrixSettings;
